import { EventForm } from "components/events";
import { useQueryTags, useQueryOrganizerVenues } from "hooks/events";
import { useQueryOrganizers } from "hooks/organizers";
import { usePreDownload } from "hooks/usePreDownload";
import { useQueryCurrentUser } from "hooks/users";
import { useQueryVenues } from "hooks/venues";

export const CreateEvent = () => {
  const currentUserQuery = useQueryCurrentUser();
  const organizerId = currentUserQuery.user?.organizer_id;
  const organizerVenues = useQueryOrganizerVenues(organizerId);

  const { isLoading, isError, error, organizers, venues, tags, currentUser } =
    usePreDownload([
      {
        hookName: "organizers",
        hook: useQueryOrganizers({ page: 1, perPage: 1000 }),
      },
      { hookName: "venues", hook: useQueryVenues({}) },
      { hookName: "tags", hook: useQueryTags() },
      { hookName: "currentUser", hook: useQueryCurrentUser() },
    ]);

  if (isLoading || currentUserQuery.isLoading || organizerVenues.isLoading) {
    return null;
  }
  if (isError) {
    return (
      <div>
        Something went wrong:
        {error?.message}
      </div>
    );
  }
  return (
    <EventForm
      isNew
      venues={venues?.venues || []}
      organizers={
        organizers?.organizers.map((organizer: Record<string, any>) => ({
          id: organizer.id,
          name: organizer.name,
        })) || []
      }
      tags={tags.tags || []}
      currOrganizerId={currentUser.user.organizer_id}
      organizerVenues={organizerVenues.data}
    />
  );
};
